import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import * as QueryString from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link, Redirect } from 'react-router-dom';
import { Form, Row, Col, Image } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';

class ReceptoresPasswordReset extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({})),
      verify: false
    };

    this.recaptchaRef = createRef();
  }

  componentDidMount = async () => {
    this.setState({
      busy: true
    });

    try {
      const { search = '' } = this.props.location || {};

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post(`receptores/password/reset/${search}`, {}, { headers });

      this.setState({
        rfc: response.rfc,
        busy: false,
        verify: true
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false,
        verify: false,
      });
    }
  }

  getRules(data) {
    return {
      password: ['required', 'confirmed', 'min:8', 'password'],
      password_confirmation: ['required', 'min:8', 'password'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true,
      error: null
    });

    try {
      const challenge = await this.recaptchaRef.current.executeAsync();

      const query = QueryString.parse(this.props.location.search);

      const params = {
        ...this.state.data,
        challenge: challenge,
        token: query.token,
        rfc: this.state.rfc
      }

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post('/receptores/auth/password/reset', params, { headers });

      const { access_token, cliente, empresa, ...rest } = response;

      const user = {
        ...rest,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const data = {
        tenancy: query.tenancy,
        token: { access_token },
        user,
        empresa: empresa || {},
        emisor: {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        isLoggedIn: true,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  handleOnAction = () => {
    const query = QueryString.parse(this.props.location.search);

    const pathname = !!query.tenancy ? `/ext/receptores/auth/login?tenancy=${query.tenancy}` : '/ext/receptores/auth/login';

    this.props.history.replace(pathname);
  }


  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      isValid,
      busy,
      error,
      validator,
      isLoggedIn,
      rfc,
      verify
    } = this.state;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };

      if (from.pathname === '/ext/receptores/auth/login') {
        from.pathname = '/ext/receptores/facturas';
      }

      return <Redirect to="/bridge/receptores" state={ from } />;
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <Row className="auth-logo">
              <Col className="d-flex justify-content-start logo-container">
                  <Image src="/img/logo.png"
                    className="auth-logo-img"
                    fluid={ true }
                  />
                  <span>Facturotöpía</span>
              </Col>
            </Row>
          </div>

          <div className="login-content">
            <div className="pb-3">
              <h6 className="text-muted">
                Nueva Contraseña
              </h6>
            </div>

            { !!verify && (
              <div className="form-box">
                <p className="text-muted">
                  Para proteger tu cuenta asegúrate de que tu contraseña:
                </p>
                <ul>
                  <li>Sea de al menos 8 caracteres</li>
                  <li>No contenga tu RFC o nombre (No usar TURFC123)</li>
                  <li>Contenga al menos una mayúscula, un número y un caracter especial ($%&#.?¡@/)</li>
                </ul>

                <FormControl type="text"
                  label="RFC"
                  name="rfc"
                  autoFocus={ true }
                  validator={ validator }
                  value={ rfc }
                  onChange={ this.handleOnChange }
                  readOnly
                />

                <FormControl type="password"
                  label="Contraseña"
                  name="password"
                  validator={ validator }
                  value={ data.password }
                  onChange={ this.handleOnChange }
                />

                <FormControl type="password"
                  name="password_confirmation"
                  label="Confirmar Contraseña"
                  validator={ validator }
                  value={ data.password_confirmation }
                  onChange={ this.handleOnChange }
                />

                <ReCAPTCHA
                  size="invisible"
                  ref={ this.recaptchaRef }
                  sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                  onChange={ this.onCaptchaChange }
                />

                <Row>
                  <Col className="text-right">
                    <LoadingButton type="button"
                      block={ true }
                      loading={ busy }
                      disabled={ !isValid || busy }
                      onClick={ this.handleOnSubmit }
                    >
                      { busy && 'Solicitando...'}
                      { !busy && 'Cambiar mi contraseña' }
                    </LoadingButton>
                  </Col>
                </Row>

                <div className="pt-3">
                  { !!error && this.renderError() }
                </div>
              </div>
            )}
          </div>

          { !verify && (
            <>
              <p className="text-muted">
                El link para cambiar tu contraseña ha expirado o es inválido, por favor inicia el proceso nuevamente o contacta a tu proveedor.
              </p>

              <div className="pt-3">
                { !!error && this.renderError() }
              </div>

              <Col className="text-center py-3">
                  <Link to="/ext/receptores/password/email">
                    Solicitar Invitación
                  </Link>
              </Col>
            </>
          )}

        </div>
      </Form>
      )
    }
  }

  export default ReceptoresPasswordReset;